var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"link":"","color":"warning"},on:{"click":_vm.reset}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-key")])],1),_c('v-list-item-title',[_vm._v("Passwort zurücksetzen")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }